<template>
  <div>
    <span>
      <button
        v-on:click="cariEkstre()"
        style="border: none; background: none; margin-right: 5px"
      >
        <Icon icon="akar-icons:search" color="#7367f0" width="15" height="15" />
      </button>
    </span>

    <span>
      <button
        v-on:click="arizaKopyala()"
        style="border: none; background: none; margin-right: 5px"
      >
        <Icon icon="akar-icons:copy" color="#ea5455" width="15" height="15" />
      </button>
    </span>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import "boxicons";
import { Icon } from "@iconify/vue2";
import router from "../../../../router";
import { BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
  components: {
    BDropdown,
    BDropdownItem,
    Icon
  },
  methods: {
    arizaKopyala() {
      var kontrol = "true";
      this.$store.commit("account/IADEARIZA_DETAY", this.params.data);
      localStorage.setItem("IADEARIZA_DETAY_ISLEM", this.params.data.ISLEM);
      localStorage.setItem("IADEARIZA_DETAY_RECEIPTID", this.params.data.RECEIPTID);
      localStorage.setItem("IADEARIZA_DETAY_KONTOL", kontrol);

      let routeData = this.$router.resolve({
        name: "SatinalmaIadearizaDetay",
        params: { item: this.params.data, kontrol: kontrol }
      });
      window.open(routeData.href, "_blank");
    },
    cariEkstre() {
      var kontrol = "false";
      console.log(this.params.data);
      this.$store.commit("account/IADEARIZA_DETAY", this.params.data);
      localStorage.setItem("IADEARIZA_DETAY_ISLEM", this.params.data.ISLEM);
      localStorage.setItem("IADEARIZA_DETAY_RECEIPTID", this.params.data.RECEIPTID);
      localStorage.setItem("IADEARIZA_DETAY_KONTOL", kontrol);

      let routeData = this.$router.resolve({
        name: "SatinalmaIadearizaDetay",
        params: { item: this.params.data }
      });
      window.open(routeData.href, "_blank");
    },

    getMuhasebeKategorileri() {
      let routeData = this.$router.resolve({
        name: "muhasebe-kategorileri"
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>
